export default __webpack_public_path__ + "static/media/arrow-prev.16b61ce7.svg";